import { useGetSpendingLimitRequest } from '@api/lendingAPI/lapiHooks';

import SpendingLimitView from '../SpendingLimitView/SpendingLimitView';

export function NoPlansView({
    setIsSpendingLimitDrawerOpen,
    loadingRefreshSpendingLimit,
    refreshSpendingLimit
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    refreshSpendingLimit: () => void;
    loadingRefreshSpendingLimit: boolean;
}) {
    const { spendingLimitRequest, loadingSpendingLimitRequest } =
        useGetSpendingLimitRequest();

    if (loadingSpendingLimitRequest) return null;

    return spendingLimitRequest?.uuid ? (
        <SpendingLimitView
            setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
            loadingRefreshSpendingLimit={loadingRefreshSpendingLimit}
            refreshSpendingLimit={refreshSpendingLimit}
        />
    ) : null;
}
